
<div class="checkout-form-container checkout-form">
  <p class="cart-card-title">Tell us about yourself</p>

  <section class="my-body-section mt-5">
    <div class="flex flex-col gap-3">

      <div class="flex flex-col 1170-bp:flex-row gap-3 1170-bp:gap-0">
        <label class="container mr-3">
          <span class="span"><b class="required-star">*</b> First Name</span>
          <validated-input v-model="updates.firstName" page="quote-builder" :showInfoIcon="false" name="First name" />
        </label>
        <label class="container">
          <span class="span"><b class="required-star">*</b> Last Name</span>
          <validated-input v-model="updates.lastName" name="Last name" page="quote-builder" :showInfoIcon="false" rules="required" />
        </label>
      </div>

      <div class="flex flex-col 1170-bp:flex-row  gap-3 1170-bp:gap-0">
        <label class="container mr-3">
          <span class="span"><b class="required-star">*</b> Email</span>
          <validated-input v-model="updates.email" name="Email" page="quote-builder" :showInfoIcon="false" rules="required|email" />
        </label>
        <label class="container">
          <span class="span"><b class="required-star">*</b> Phone</span>
          <validated-input v-model="updates.phone" name="Phone" page="quote-builder" :showInfoIcon="false" :rules="{ required: true, regex: /^\+?[0-9\s()-]*$/ }" />
        </label>
      </div>
      
      <div class="is-flex flex is-justify-content-space-between w-full gap-3 1170-bp:gap-0">
        <label class="container" >
          <span class="span">Company Name <span class="optional-flag">(optional)</span></span>
          <validated-input v-model="customer.companyName" name="Company" page="quote-builder" :showInfoIcon="false" :rules="{ required: false }" />
        </label>
      </div>
    </div>
  </section>   
</div>
